import React from 'react';
import NewsletterSignup from './NewsletterSignup';
import { Link } from 'react-router-dom';


function Footer() {
  return (
    <footer style={{
      backgroundColor: '#121212',
      color: '#ccc',
      padding: '2rem',
      textAlign: 'center',
      marginTop: '4rem',
      fontSize: '0.9rem'
    }}>
        <NewsletterSignup></NewsletterSignup>

      <div style={{ marginBottom: '0.5rem' }}>
        {`© ${new Date().getFullYear()} Meshum. All rights reserved.`}
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '1.5rem', flexWrap: 'wrap' }}>
       <Link to="/about" style={{ color: "#ccc" }}>About</Link>
       <Link to="/research" style={{ color: "#ccc" }}>Research</Link>
       <Link to="/blog" style={{ color: "#ccc" }}>Blog</Link>
       <Link to="/terms-of-use" style={{ color: "#ccc" }}>Terms of Use</Link>
        <Link to="/privacy-policy" style={{ color: "#ccc" }}>Privacy Policy</Link>
        <Link to="mailto:contact@meshum.com" style={linkStyle}>Contact</Link>
      </div>
      <p className="recaptcha-disclosure">
        <span>This site is protected by reCAPTCHA and the Google </span>
        <a href="https://policies.google.com/privacy" style={linkStyle}>Privacy Policy</a>
        <span> and </span>
        <a href="https://policies.google.com/terms" style={linkStyle}>Terms of Service</a>
        <span> apply.</span>
      </p>
    </footer>
  );
}

const linkStyle = {
  color: '#bbb',
  textDecoration: 'none',
  fontWeight: 500
};

export default Footer;
